export const alphabetChars = Array(26)
  .fill({})
  .map((_, i) => String.fromCharCode(65 + i));
